import { _ } from '@splunk/ui-utils/i18n';
import type { PresetHOC } from '../types/PresetHOC';

export const withSetTimeRange: PresetHOC<{
    canSetTimeRange?: boolean;
    interactionsFilterMetadata?: string[];
}> = (Item) => {
    Item.canSetTimeRange = true;
    Item.interactionsFilterMetadata ??= [];
    Item.interactionsFilterMetadata.push(_('Set time range'));

    return Item;
};
